<template>
  <Layout :containers="containers">
    <template v-slot:header>
      <DefaultHeroBar
        :hasQuickStartCallout="false"
        :heroTitle="'Planning for the Future: What You Need to Know'"
        :heroDescription="'Our experts have crafted articles on key topics to help you make informed decisions for your future.'"
        :section="'articles'"
      />
    </template>
    <template v-slot:articles-top>
      <Breadcrumb />
      <TitleRow
        :html="true"
        :title="`Our latest <span style='font-weight:500;'>article</span>`"
        :description="''"
      />
      <ImageTextBanner
        :imageUrl="latestArticle.imageUrl"
        :title="latestArticle.heroTitle || latestArticle.title"
        :paragraphOne="
          latestArticle.heroDescription || latestArticle.description
        "
        :reversed="false"
        :buttonText="'Read More'"
        @gradientButtonClicked="readMore(latestArticle.id)"
        :date="latestArticle.date"
        :category="latestArticle.category"
        :bottomMargin="false"
      />
    </template>
    <template v-slot:articles>
      <div class="section-padding">
        <ArticleTilesContainer :tiles="articleTiles" :articles="articles" />
      </div>
    </template>
  </Layout>
</template>
<script>
import Breadcrumb from "../../common/Breadcrumb.vue";
import TitleRow from "../../common/TitleRow.vue";
import Layout from "../../common/layouts/Layout.vue";
import DefaultHeroBar from "../../common/DefaultHeroBar.vue";
import HR from "../../common/HR.vue";
import ImageTextBanner from "../ImageTextBanner.vue";
import ArticleTilesContainer from "./ArticleTilesContainer.vue";
import Article from "./Article.vue";
export default {
  name: "Articles",
  components: {
    Breadcrumb,
    ArticleTilesContainer,
    ImageTextBanner,
    Layout,
    DefaultHeroBar,
    HR,
    TitleRow,
    Article,
  },
  metaInfo() {
    return {
      title: this.whitelabel.metaData.articles.title,
      meta: [
        {
          name: "description",
          content: this.whitelabel.metaData.articles.description,
        },
        {
          property: "og:title",
          content: this.whitelabel.metaData.articles.ogTitle,
        },
        {
          property: "og:image",
          content: this.whitelabel.metaData.articles.ogImage,
        },
        {
          property: "og:type",
          content: this.whitelabel.metaData.articles.ogType,
        },
        {
          property: "og:url",
          content: this.whitelabel.metaData.articles.ogUrl,
        },
        {
          property: "og:description",
          content: this.whitelabel.metaData.articles.description,
        },
        {
          property: "og:site_name",
          content: this.whitelabel.metaData.articles.ogSiteName,
        },
      ],
    };
  },
  data() {
    return {
      latestArticle: null,
    };
  },
  methods: {
    login() {
      this.$router.push({ name: "Login" });
    },
    readMore(id) {
      const article = this.articles.find((article) => article.id === id);
      this.$router.push({
        name: "Article",
        params: {
          title: article.route,
        },
      });
    },
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
    containers() {
      return [
        {
          name: "header",
          background: "countryPattern",
          class: "hero-banner",
        },
        {
          name: "articles-top",

          accents: ["green-accent-1"],
          class: "articles",
          hr: true,
        },
        { name: "articles", accents: ["purple-accent-1"] },
        { name: "create-my-will" },
      ];
    },
    articleTiles() {
      return this.whitelabel.articleTiles.sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
    },
    articles() {
      return this.whitelabel.articles;
    },
  },
  mount() {},
  created() {
    this.latestArticle = this.articles.reduce((mostRecent, currentItem) => {
      return new Date(currentItem.date) > new Date(mostRecent.date)
        ? currentItem
        : mostRecent;
    });
  },
};
</script>
<style lang="scss" scoped>
.main {
  background-color: #f9f9f9;
}

.how-it-works-title-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;

  h1 {
    font-family: Montserrat;
    font-size: 28px;
    font-weight: 500;
    line-height: 34px;
    letter-spacing: -0.0025em;
    text-align: center;
    margin-bottom: 24px;
  }
  p {
    font-family: Montserrat;
    font-size: 22px;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
    margin-bottom: 53px;
  }
}
.content-container {
  width: clamp(300px, 95%, 1600px);
  z-index: 12;

  &.breadcrumb {
    max-width: unset !important;
    padding-top: 24px;
  }
}

.fluid-container {
  padding: 0;
  margin: 0;
  &.create-your-will {
    max-height: 309px !important;
    position: relative;
    background-color: white;
    z-index: 12;
    .content-row {
      margin-top: unset;
    }
  }
}

.fade-row {
  position: relative;
  background: linear-gradient(
    to bottom,
    rgba(249, 249, 249, 0.2) 0%,
    rgba(249, 249, 249, 0.3) 15%,
    rgba(249, 249, 249, 0.4) 30%,
    rgba(249, 249, 249, 0.4) 45%,
    rgba(249, 249, 249, 0.7) 65%,
    rgba(249, 249, 249, 0.9) 85%,
    rgba(249, 249, 249, 1) 100%
  );
  z-index: 12;
}
.content-row {
  padding: 88px 0;
  margin-top: auto;
  &.hr {
    padding: 0;
  }

  &.calculator-banner,
  &.further-questions {
    position: relative;
  }

  &.breadcrumb {
    padding-top: 0;
  }
}

.green-accent-1 {
  position: absolute;
  width: 150px;
  left: 0;
  top: 25px;
}
.green-accent-2 {
  position: absolute;
  top: 140px;
  width: 320px;
  left: -120px;
}
.purple-accent {
  position: absolute;
  width: 200px;
  right: -50px;
  bottom: 384px;
}

@media only screen and (min-width: 0px) and (max-width: 959px) {
  .content-container {
    margin: 0;
  }
  .content-row {
    padding: 52px 0;
  }
}
</style>
